

<ng-template let-selectableData #creditCardPayOptionTmplt [appControlTemplate]="'creditCardPayOptionTmplt'">
    <box class="pay-option-item">
        <span>{{ selectableData?.text.description | translate }}</span>
        <span class="pay-amount">{{selectableData?.text.value | currency : selectableData?.text.currency : '' }}</span>
    </box>
</ng-template>

<ng-template let-selectableData #OTPChannelOptionTmplt [appControlTemplate]="'OTPChannelOptionTmplt'">
    <box class="pay-option-item">
        <span class="email-notification" *ngIf="selectableData.id=='1'"><img  src="./assets/images/email_notification.svg" /></span>
        <span class="mobile-notification" *ngIf="selectableData.id=='2'"><img  src="./assets/images/mobile_notification.svg" /></span>
        <span class="whatsapp-notification" *ngIf="selectableData.id=='5'"><img  src="./assets/images/mobile_whatsapp.png" /></span>

        <span>{{ selectableData?.text }}</span>
    </box>
</ng-template>

<ng-template let-selectableData #videoCaptureBtnTmplt [appControlTemplate]="'videoCaptureBtnTmplt'">
    <span>Record video</span>
</ng-template>





